import React from 'react';
import useVerifInternet from './verifInternet';

const StatutInternet = () => {
    const isOnline = useVerifInternet();

    return (
        <div style={{ position: 'relative', marginTop: '15px', marginLeft: '30px' }}>
            {/* Indicateur de statut (Cercle vert ou rouge) */}
            <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: isOnline ? 'green' : 'red',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                zIndex: 1000
            }}>
            </div>

            {/* Bulle d'alerte si l'utilisateur est hors ligne */}
            {!isOnline ? (
                <div style={{
                    position: 'absolute',
                    top: '-30px',
                    left: '25px', // Déplace la bulle à gauche du cercle
                    backgroundColor: 'red',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.2)',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    width: '310px',
                    animation: 'slideLeftRight 1.5s infinite alternate ease-in-out',
                    // whiteSpace: 'nowrap' // Évite le retour à la ligne
                }}>
                    Hors connexion ! Veuillez vous reconnecter à internet, sans quoi votre examen prendra fin dans les 10 prochaines minutes.
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '-5px', // Place la flèche sur le côté gauche
                        transform: 'translateY(-50%)',
                        width: '0',
                        height: '0',
                        borderTop: '5px solid transparent',
                        borderBottom: '5px solid transparent',
                        borderRight: '5px solid red' // Change l'orientation de la flèche
                    }}></div>
                </div>
            ) : (
                <div style={{
                    position: 'absolute',
                    top: '-5px',
                    left: '15px', 
                    color: 'green',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    animation: 'slideLeftRight 1.5s infinite alternate ease-in-out',
                    whiteSpace: 'nowrap'
                }}>
                    En ligne
                </div>
            )}

            {/* Animation CSS */}
            <style>
                {`
                    @keyframes slideLeftRight {
                        0% { transform: translateX(0px); }
                        100% { transform: translateX(8px); }
                    }
                `}
            </style>
        </div>
    );
};

export default StatutInternet;
